module.exports = __webpack_public_path__ + "img/las-palmas-logo-icon.682ef680.png";